<template lang="pug">
.modal-card
  header.modal-card-head
    p.modal-card-title(data-qa="modal-header") 
      b(v-t="'appointment.block_time_title'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body
    b-field(:label="$t('appointment.block_time_location')" v-if="hasMultipleLocations")
      location-view(:value="locationId")
    b-field(:label="$t('appointment.block_time_date_label')")
      date-view(:value="date" format="dddd, D MMM, YYYY")
    b-field(v-if="scope !== 'resource'" :label="$t('appointment.block_time_staff')")
      .is-flex
        .brand-bordered.px-3.py-2.mr-4
          StaffSelectDropdown(:has-preferred="false" v-model="staff" :location-id="locationId")
    b-field(v-else :label="$t('appointment.block_time_resource')")
      .is-flex
        .brand-bordered.px-3.py-2.mr-4.is-flex
          ResourceSelectDropdown(:has-preferred="false" v-model="resource" :location-id="locationId")
    .columns
      .column
        b-field(:label="$t('appointment.block_time_from_label')" expanded)
          timepicker(icon="clock-outline" v-model="from" expanded @input="onTimeUpdate('from')")
      .column
        b-field(:label="$t('appointment.block_time_to_label')" expanded)
          timepicker(icon="clock-outline" v-model="to" expanded @input="onTimeUpdate('to')")
    b-field(:label="$t('appointment.block_time_reason_label')" :type="errors.has('reason') ? 'is-danger': ''" :message="errors.has('reason') ? errors.first('reason') : ''")
      b-input(type="textarea" ref="reasonInput" v-model="reason" v-validate="'required'" name="reason")
  footer.modal-card-foot
    action-button(title="actions.submit" @click="submit" :loading="submitting")
    button.button(@click="$emit('close')" v-t="'actions.cancel'") 
    
</template>
<script>
import dayjs from 'dayjs'
import {mapActions, mapGetters} from 'vuex'
import StaffSelectDropdown from '../staff/StaffSelectDropdown.vue'
import ResourceSelectDropdown from '../staff/ResourceSelectDropdown.vue'

export default {
  name: 'BlockTimeModal',
  components: {
    StaffSelectDropdown,
    ResourceSelectDropdown
  },
  props: {
    date: {type: Date, required: true},
    scope: {type: String, required: true},
    locationId: {type: String, required: true}
  },
  data() {
    return {
      submitting: false,
      from: 960,
      to: 1080,
      staff: undefined,
      resource: undefined,
      reason: undefined
    }
  },
  computed: {
    ...mapGetters('location', ['hasMultipleLocations'])
  },
  created() {
    let start = new Date()
    start.setMinutes(parseInt(start.getMinutes() / 10) * 10, 0, 0)
    this.from = start.getHours() * 60 + start.getMinutes() + 10
    this.to = Math.min(this.from + 30, 24 * 60)
  },
  mounted() {
    this.$refs.reasonInput.focus()
  },
  methods: {
    ...mapActions('appointments', ['blockTime']),
    async submit() {
      if (this.submitting) {
        return
      }
      let valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.submitting = true
      try {
        await this.blockTime({
          location: this.locationId,
          staff: this.staff && this.staff.staffId,
          resource: this.resource && this.resource.resourceId,
          start: dayjs(this.date)
            .startOf('day')
            .add(this.from, 'minutes')
            .toDate(),
          duration: this.to - this.from,
          reason: this.reason
        })
        this.$buefy.toast.open({
          message: this.$t('status.save_success'),
          queue: false,
          position: 'is-top',
          type: 'is-success'
        })
        this.$emit('close')
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.submitting = false
    },
    onTimeUpdate(field) {
      if (field === 'from' && this.from > this.to) {
        this.to = Math.min(this.from + 10, 24 * 60)
      }
      if (field === 'to' && this.from > this.to) {
        this.from = Math.max(this.to - 10, 0)
      }
    }
  }
}
</script>
